"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Menu } from "lucide-react";
import { Logo } from "./Logo";
import { ThemeToggle } from "./ThemeToggle";
import { MobileMenu } from "./MobileMenu";

const NAV_LINKS = [
  { label: "Home", anchor: "home" },
  { label: "About", anchor: "about" },
  { label: "Services", anchor: "services" },
  { label: "Portfolio", anchor: "portfolio" },
  { label: "Testimonials", anchor: "testimonials" },
  { label: "Contact", anchor: "contact" },
];

export function NavBar() {
  const pathname = usePathname();
  const [menuOpen, setMenuOpen] = useState(false);
  const onHome = pathname === "/";

  const linkFor = (anchor: string) => (onHome ? `#${anchor}` : `/#${anchor}`);

  return (
    <>
      <nav className="sticky top-0 z-50 bg-surface-light/90 dark:bg-surface-dark/90 border-b border-line-light dark:border-line-dark backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Logo />

            <div className="hidden md:flex items-center gap-6 lg:gap-8">
              {NAV_LINKS.map((item) => (
                <Link
                  key={item.anchor}
                  href={linkFor(item.anchor)}
                  className="font-body text-[14px] font-medium text-muted-light dark:text-muted-dark hover:text-ink-light dark:hover:text-ink-dark transition-colors duration-200"
                >
                  {item.label}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-3 md:gap-4">
              <ThemeToggle />
              <button
                type="button"
                onClick={() => setMenuOpen(true)}
                aria-label="Open menu"
                className="md:hidden w-10 h-10 rounded-xl bg-surface-light dark:bg-surface-dark border border-line-light dark:border-line-dark flex items-center justify-center shadow-card dark:shadow-card-dark"
              >
                <Menu className="w-5 h-5 text-brand-400" />
              </button>
            </div>
          </div>
        </div>
      </nav>

      <MobileMenu
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        links={NAV_LINKS.map((l) => ({ label: l.label, href: linkFor(l.anchor) }))}
      />
    </>
  );
}
